import React from "react";
import { fontSize } from "../../styles/fonts";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";

export const PDPReviewCommentTopBarShell: React.FC<{
  leftSide: React.ReactNode;
  rightSide: React.ReactNode;
}> = ({ leftSide, rightSide }) => {
  return (
    <div
      css={css`
        ${CSS_MQ.atMostSm} {
          flex-direction: column;
        }

        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 24px;
      `}
    >
      <span className="u-flex u-gap-6" css={fontSize.x2}>
        {leftSide}
      </span>

      <span>{rightSide}</span>
    </div>
  );
};
